import { Class, ExternalSync } from './Class';
import { Network } from './Network';
import { Role } from './Role';
import { Site } from './Site';
export default interface User {
  id?: string;
  name?: string;
  email: string;
  email_verified: boolean;
  isActive?: boolean;
  sub?: string;
  updated_at: string;
  nickname: string;
  picture?: string;
  roles: Role[];
  gradeLevel?: {
    id: string;
    name?: string | null;
  } | null;
  sites?: Site[];
  activeTimeZone: string;
  gradeLevels?:
    | {
        id: string;
        name?: string | null;
      }[]
    | null;
  firstName?: string;
  lastName?: string;
  classes?: Class[];
  userClasses?: UserClass[];
  externalSync?: ExternalSync;
  hasUserClassWithActiveStudent?: boolean;
  network: Network | null;
  customBrandingApplied: CustomBranding;
  userGuidingHash: string | null;
  isInternalUser: boolean;
}

interface UserClass {
  isActive: boolean;
  id: string;
  class: Class;
}

export enum CustomBranding {
  MIAMI,
  RHODE_ISLAND,
  NO_APPLY,
}

export const mapCustomBranding: { [key: string]: CustomBranding } = {
  'theme-miami': CustomBranding.MIAMI,
  'theme-rhode-island': CustomBranding.RHODE_ISLAND,
  null: CustomBranding.NO_APPLY,
};

export enum Roles {
  INTERNAL_ADMIN = 'internal admin',
  STUDENT = 'student',
  TEACHER = 'teacher',
  NETWORK_ADMIN = 'network admin',
  SITE_ADMIN = 'site admin',
}
